import React, { Component } from "react";
import { Div, Button, P, H1 } from "glamorous";
import { setGlobal } from 'reactn';
import Upload from "./Upload";
import data from "../../data";
import styles from "../../styles";
import { track } from "../../misc/utils";
import { baseURL, get } from "../../misc/api";
class Landing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      country: null,
      locations: [],
      brandId: process.env.REACT_APP_BRAND_ID,
      timerId: null,
    };

  }

  async componentDidMount () {
    const locations = this.global ? this.global.locations : [];
    if (locations && locations.length > 0) {
      this.setState({
        locations
      })
    } else {
      let locations = [];
      const brandId = this.state.brandId;
      await get(baseURL + '/location/' + brandId)
        .then(response => {
          locations = response.map(location => {
            return {
              value: location.locationId,
              label: location.locationName + ' - ' + location.countryCode.toUpperCase(),
              country: location.countryCode
            };
          });
          this.setState({
            locations,
          });
          setGlobal({
            locations,
          });
        })
        .catch(error => {
          console.log('get location', error);
          // alert("Unable to get locations list");
        })
        ;
      if (undefined !== data.journey && (data.journey.toLowerCase() === 'instore' || data.journey.toLowerCase() === 'instoreba')) {
        var timerId = setInterval(() => {
          this.setCountryFromAgeGateCookie();

          if (this.state.country && this.state.locations.length > 0) {
            clearInterval(timerId);
            let filteredLocations = locations.filter(location => {
              return location.country === this.state.country;
            });
            this.setState({
              locations: filteredLocations
            });

            setGlobal({
              userCountry: this.state.country,
              locations: filteredLocations
            });
          }
        }, 1000);

        this.setState({
          timerId: timerId
        });
      }
    }
  }

  getUrlParams (url) {
    let urlStr = url.split('?')[1]
    let obj = {};
    let paramsArr = urlStr.split('&')
    for (let i = 0, len = paramsArr.length; i < len; i++) {
      let arr = paramsArr[i].split('=')
      obj[arr[0]] = arr[1];
    }
    return obj
  }

  setCountryFromAgeGateCookie () {
    let found = document.cookie.split(';').filter(c => c.trim().split("=")[0] === 'diageo-gateway');
    const {agp} = this.props;
    try {
      if (agp ==='true') {
        const iframeSrc = window.location.href;
        const iframeParamsObj = this.getUrlParams(iframeSrc);
        const agData = iframeParamsObj['diageoGateway'];
        if (agData) {
          found = [`diageo-gateway=${agData}`];
        }
      }
    } catch (e) {
      console.log('iframe error', e);
    }
    if (Array.isArray(found) && found.length > 0) {
      found = decodeURIComponent(found).split('=');
      let values = JSON.parse(found[1]);
      this.setState({
        country: values.country
      });
    }
  }

  render () {
    const { productId, setArea, setLoading, setImage, setError } = this.props;
    return (<Div className="container" css={styles.landing.container}>
      <Div css={styles.landing.wrapper}>
        <H1 css={styles.landing.title}>{data.copy("landingHeadline")}</H1>
        <H1 css={styles.landing.product}>
          {data.productsById[productId].name}
        </H1>
        <Button
          onClick={() => {
            track.event("button", "click", "Select_Background");
            setArea("SelectBackground");
          }}
          css={styles.ctas.initial}
        >
          {data.copy("selectlabelBtn")}
        </Button>
        <P css={styles.landing.separator}>{data.copy("landingOr")}</P>
        <Upload
          setLoading={setLoading}
          setImage={setImage}
          setError={setError}
          setArea={setArea}
        />
      </Div>
    </Div>);

  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/areas/Landing.js